import { createContext, type ReactNode, useContext } from 'react';

type LayoutOffsetContextValue = {
  rightOffset: number;
  additionalLeftOffset: number;
};

const LayoutOffsetContext = createContext<LayoutOffsetContextValue>({
  rightOffset: 0,
  additionalLeftOffset: 0,
});

type LayoutOffsetProviderProps = {
  children: ReactNode;
  rightOffset?: number;
  /** 第2メニュー等による追加の左オフセット（px） */
  additionalLeftOffset?: number;
};

export const LayoutOffsetProvider = ({
  children,
  rightOffset,
  additionalLeftOffset,
}: LayoutOffsetProviderProps) => {
  const parent = useContext(LayoutOffsetContext);
  return (
    <LayoutOffsetContext.Provider
      value={{
        rightOffset: rightOffset ?? parent.rightOffset,
        additionalLeftOffset: additionalLeftOffset ?? parent.additionalLeftOffset,
      }}
    >
      {children}
    </LayoutOffsetContext.Provider>
  );
};

export const useLayoutOffset = () => {
  return useContext(LayoutOffsetContext);
};
